<template>
  <div class="default">
    <section class="zone-title">
      <img src="../assets/img/title_img.png" alt="">
    </section>
    <section class="zone-code">
      <div class="zone-code-in">
        <span ref="myCodeSpan" class="code" style="overflow:hidden;">
          {{code}}
          <span ref="myCodeInput" style="width:0;height:0;">{{code}}</span>
        </span>
        <a ref="refBtnCopy" @click="copy"><img src="../assets/img/copy.png" /></a>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
// import Clipboard from "clipboard";
const H5Tracer = require("../utils/H5Tracer.js").H5Tracer
export default {
  data(){
    return {
      code: '--------',
    }
  },
  mounted() {
    axios.get(process.env.VUE_APP_ENV_INTERFACE_PREFIX + '/invitecode/getNewWebRewardCode').then(res => {
      console.log('res => ', res.data)
      if (res.data && res.data.Result === 1) {
        this.code = res.data.data
      }
    })
  },
  methods: {
    copy() {
      try {
        if (document.body.createTextRange) {
            const range = document.body.createTextRange();
            range.moveToElementText(this.$refs.myCodeInput);
            range.select();
        } else if (window.getSelection) {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(this.$refs.myCodeInput);
            selection.removeAllRanges();
            selection.addRange(range);
            /*if(selection.setBaseAndExtent){
                selection.setBaseAndExtent(text, 0, text, 1);
            }*/
        } else {
            console.warn("none");
        }
        document.execCommand("copy")
        this.$toast({
          message: "I copied: " + this.code,
        });
        window.gtag("event", "Click", {
          event_category: "Copy_Code",
          event_action: "Click",
          event_label: "copy_success",
          event_value: document.referrer
        })
        H5Tracer.invoke("Copy_Code", {
          url: window.location.href,
          referrer: document.referrer
        });
      }
      catch(ex) { 
        console.log('ex ', ex)
        // window.gtag("event", "Click", {
        //   event_category: "Copy_Code",
        //   event_action: "Click",
        //   event_label: "copy_failed",
        //   event_value: document.referrer
        // })
        // this.$toast({
        //   message: "I copied failed: " + JSON.stringify(ex),
        // });
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.default {
  padding: 24px 20px;
  background-color: #E4EFFF;
  height: 100%;
}

.zone-title {
  padding: 0 50px;
}
.zone-title img {
  width: 100%;
  height: auto;
}

.zone-banner {
  margin-top: 25px;
}
.zone-banner img {
  width: 100%;
  height: auto;
}

.zone-code {
  margin-top: 15px;
}
.zone-code-in {
  margin-top: 16px;

  background: #BCD6FF;
  border-radius: 14px;
  line-height: 104px;
  text-align: center;
  vertical-align: middle;
}
.zone-code-in img {
  display: inline-block;
  height: 51px;
  width: auto;
  margin: 0 0 -10px 11px;

  vertical-align: middle;
}
.zone-code-in span {
  display: inline-block;

  font-size: 37px;
  font-family: SFProDisplay-Heavy, SFProDisplay;
  font-weight: 800;
  color: #000000;
  vertical-align: middle;
}
</style>
